import React from "react";

function Footer() {
  return <div style={{ margin: "10px" }}></div>;
}

export default Footer;
